// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_vendor,
  add_vendor,
  update_vendor,
  delete_vendor,
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";
const initialState = {
  vendors: [],
  vendorlist: [],
  vendorfilterlist: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    store_name: "",
    description: "",
    address: "",
    mobile_no: "",
    email: "",
    gst_no: "",
    
  },
};
// Async Thunks for API Calls
// export const fetchvendorList = createAsyncThunk(
//   "vendor/fetchvendorList",
//   async ({school_id,department_id, token, signal }, { rejectWithValue }) => {
//     try {
//       const response = await get_vendor_list(school_id,department_id, token, signal);
//       if (response.status) {
//         return response.response;
//       } else {
//         return rejectWithValue(response.response.message);
//       }
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// Async Thunks for API Calls
export const fetchvendor = createAsyncThunk(
  "vendor/fetchvendor",
  async ({ page, page_size,school_id,token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_vendor(page, page_size,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createvendor = createAsyncThunk(
  "vendor/createvendor",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_vendor(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatevendor = createAsyncThunk(
  "vendor/updatevendor",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_vendor(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletevendor = createAsyncThunk(
  "vendor/deletevendor",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_vendor({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const vendorSlice = createSlice({
  name: "vendors",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(reduxState, action) {
        reduxState.formData = { ...action.payload };
      },
    resetFormData(state) {
      state.formData = {
        store_name: "",
        description: "",
        address: "",
        mobile_no: "",
        email: "",
        gst_no: "",
      };
    },
    setvendor(state, action) {
      state.vendors = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // User list
    //   .addCase(fetchvendorList.fulfilled, (state, action) => {
    //     state.vendorlist = action.payload.data;
    //   })
    //   .addCase(fetchvendorList.rejected, (state, action) => {
    //     state.vendorlist = [];

    //   })
      // Fetch Classes
      .addCase(fetchvendor.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchvendor.fulfilled, (state, action) => {
        state.loading = false;
        state.vendors = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchvendor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createvendor.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createvendor.fulfilled, (state, action) => {
        state.addLoading = false;
        state.vendors = action.payload.data;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createvendor.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updatevendor.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatevendor.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatevendor.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete Class
      .addCase(deletevendor.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletevendor.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletevendor.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");

        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setvendor,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setPageSize,
  setSchoolId,
} = vendorSlice.actions;
export default vendorSlice.reducer;
